import { render, staticRenderFns } from "./DashBoardDataUsage.vue?vue&type=template&id=2dc8de8c&scoped=true"
import script from "./DashBoardDataUsage.vue?vue&type=script&lang=js"
export * from "./DashBoardDataUsage.vue?vue&type=script&lang=js"
import style0 from "./DashBoardDataUsage.vue?vue&type=style&index=0&id=2dc8de8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc8de8c",
  null
  
)

export default component.exports